var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"drawer-settings-row",style:(_vm.containerStyles)},[_vm._t("default",function(){return [_c('div',{staticClass:"drawer-settings-label",style:({
				margin: _vm.hasDetails ? '0 15px 30px 0' : '0 15px 0 0',
				...(_vm.labelMarginTop && {
					marginTop: _vm.labelMarginTop,
				}),
			})},[_vm._t("label")],2),_c('div',{staticClass:"drawer-settings-setting"},[_vm._t("setting")],2)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }